import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { UserID } from '@playq/octopus-common';
import { UserPublic } from '@playq/octopus2-auth';
import { GenericFailure } from '@playq/services-shared';

import { createRequestQueue, IUseQueryOptionsExtended, unwrapEither } from '/api/service-hooks';
import { services2 } from '/api/services2';

export const usersServicePublicTags: string[] = ['users', 'service', 'public'];

const queue = createRequestQueue<UserID, UserPublic>(
  (userIds) => unwrapEither(services2.usersService.retrievePublicFor(userIds)),
  {
    predicate: (userId, user) => userId.serialize() === user?.id.serialize(),
  }
);

export const useUserPublic = (
  id: UserID,
  options?: IUseQueryOptionsExtended<UserPublic | null, GenericFailure | Error>
) =>
  useQuery<UserPublic | null, GenericFailure | Error>({
    queryKey: [...usersServicePublicTags, id.serialize()],
    queryFn: () => queue.push(id),
    staleTime: Infinity,
    placeholderData: keepPreviousData,
    ...options,
  });
